module.exports = __webpack_public_path__ + "static/praekelt-bb0044b901a0c486c34b6dbb8f5086ab.png";